// extracted by mini-css-extract-plugin
export default {"customLink":"Link_customLink__8plV8","customNoMarginLink":"Link_customNoMarginLink__xjCke"};